import { styled, Typography } from '@mui/material';
import { ItemPicker } from 'components/ItemPicker';
import Alert, { ALERT_STATUS } from 'components/interface/alert/Alert';
import { IntervalTimeOption } from 'report/logic/interval/editing';
import { formatMinutes } from './formatting';

const Choices = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
}));

const Explanation = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
}));

const clockChangeLabels = {
    before: 'Före omställningen',
    across: 'Över omställningen',
    after: 'Efter omställningen',
};

interface Props {
    options: IntervalTimeOption[];
    selected: IntervalTimeOption | null;
    disabled: boolean;
    error?: string;
    onChange: (option: IntervalTimeOption) => void;
}

export function ClockChangeOptions({
    options,
    selected,
    disabled,
    error,
    onChange,
}: Props) {
    return (
        <Choices>
            <Alert
                status={ALERT_STATUS.INFO}
                withBorder={false}
                fullWidth
                text={
                    <Explanation>
                        <Typography
                            variant='body2'
                            fontWeight={600}
                            color='inherit'>
                            Klockan ställs tillbaka
                        </Typography>
                        <Typography variant='body2' color='inherit'>
                            Vissa klockslag inträffar två gånger den här natten.
                        </Typography>
                    </Explanation>
                }
            />
            <Typography variant='body2' fontWeight={500}>
                Hur lång tid gick mellan start och slut?
            </Typography>
            <ItemPicker
                items={options}
                picked={selected}
                onPick={onChange}
                renderLabel={option => formatMinutes(option.elapsedMinutes)}
                renderSubtitle={option =>
                    option.clockChange
                        ? [clockChangeLabels[option.clockChange]]
                        : []
                }
                compareFunc={(option, picked) =>
                    option.startAt === picked?.startAt &&
                    option.endAt === picked?.endAt
                }
                disabled={disabled}
            />
            {error && (
                <Typography variant='caption' color='error'>
                    {error}
                </Typography>
            )}
        </Choices>
    );
}
